import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/styles.css';
import { toast } from 'react-toastify';
import { postCompany } from '../services/api';
import PasswordInput from './PasswordInput';
import { formatRut } from '../utils/rut';
import { validatePassword } from '../utils/password';

const CrearEmpresa = () => {
  const navigate = useNavigate();

  const [empresa, setEmpresa] = useState({
    email: '',
    password: '',
    nombre_legal: '',
    rut: '',
    ciudad: '',
    giro: '',
    razon_social: '',
    rubro: '',
    direccion: '',
    forma_pago: 'factura',
    dias_pago: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let formattedVal = value;

    if (name === "rut") {
      formattedVal = formatRut(value);
    } else if (name === "dias_pago") {
      formattedVal = value.replace(/[^0-9]/g, "");
    }

    setEmpresa((prevEmpresa) => ({
      ...prevEmpresa,
      [name]: formattedVal,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!empresa.nombre_legal || !empresa.email || !empresa.rut || !empresa.password) {
      toast.error("Por favor completa todos los campos obligatorios.");
      return;
    }
    if (!validatePassword(empresa.password)) {
      toast.error("La contraseña debe tener al menos 8 caracteres, una mayúscula y un número.");
      return;
    }

    const payload = {
      ...empresa,
      rut: empresa.rut.replace(/[^0-9kK]/g, '').toUpperCase()
    };
    if (payload.dias_pago && payload.dias_pago !== "") {
      payload.dias_pago = parseInt(payload.dias_pago, 10);
    } else {
      payload.dias_pago = null;
    }
   
    Object.keys(payload).forEach(key => {
      if (payload[key] === "") {
        payload[key] = null;
      }
    });
    try {
      const response = await postCompany(payload); // api.js
      toast.success(response.data.message || 'Empresa creada exitosamente');
      navigate('/empresas');
    } catch (error) {
      console.error('Error al crear empresa:', error.response?.data);

      if (error.response?.status === 409) {
        // Conflicto de unicidad
        const details = error.response?.data?.details;
        if (details) {
          const msgs = Object.entries(details).map(([field, msg]) => `${field}: ${msg}`);
          toast.error(<div>Conflicto de unicidad:{msgs.map((m, i) => <div key={i}>{m}</div>)}</div>);
        } else {
          toast.error("Conflicto: datos duplicados (email o RUT).");
        }
      } else if (error.response?.status === 422) {
        // Errores de validación de Marshmallow
        const validationErrors = error.response?.data?.errors?.json || error.response?.data?.details;
        if (validationErrors) {
          const msgs = Object.entries(validationErrors).map(([field, errs]) => {
            const label = field === 'rut' ? 'RUT' : field;
            const errorMessage = Array.isArray(errs) ? errs.join(', ') : errs;
            return `${label}: ${errorMessage}`;
          });
          toast.error(<div>Errores de validación:{msgs.map((m, i) => <div key={i}>{m}</div>)}</div>);
        } else {
          toast.error("Error de validación en los datos.");
        }
      } else {
        toast.error("Error inesperado al crear la empresa.");
      }
    }
  };

  return (
    <div className="content-wrapper">
      <h1>Crear Empresa </h1>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nombre Legal <span className='required-text' >*Obligatorio</span></label>
            <input
              type="text"
              name="nombre_legal"
              className="form-control"
              value={empresa.nombre_legal}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email <span className='required-text' >*Obligatorio</span></label>
            <input
              type="text"
              name="email"
              className="form-control"
              value={empresa.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <PasswordInput
            label="Contraseña"
            value={empresa.password}
            onChange={handleInputChange}
          />
          <div className="form-group">
            <label>RUT <span className='required-text' >*Obligatorio</span></label>
            <input
              type="text"
              name="rut"
              className="form-control"
              value={empresa.rut}
              onChange={handleInputChange}
              placeholder="Ej: 76.123.456-K"
              maxLength="12"
              required
            />
          </div>
          <div className="form-group">
            <label>Ciudad</label>
            <input
              type="text"
              name="ciudad"
              className="form-control"
              value={empresa.ciudad}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Giro</label>
            <input
              type="text"
              name="giro"
              className="form-control"
              value={empresa.giro}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Razón Social</label>
            <input
              type="text"
              name="razon_social"
              className="form-control"
              value={empresa.razon_social}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Rubro</label>
            <input
              type="text"
              name="rubro"
              className="form-control"
              value={empresa.rubro}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Dirección</label>
            <input
              type="text"
              name="direccion"
              className="form-control"
              value={empresa.direccion}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Forma de Pago</label>
            <select
              name="forma_pago"
              className="form-control"
              value={empresa.forma_pago}
              onChange={handleInputChange}
            >
              <option value='factura'>Factura</option>
              <option value='boleta'>Boleta</option>
            </select>
          </div>
          <div className="form-group">
            <label>Días de Pago</label>
            <input
              type="text"
              name="dias_pago"
              className="form-control"
              value={empresa.dias_pago}
              onChange={handleInputChange}
              inputMode="numeric"
              placeholder="ej: 30"
            />
          </div>

          <button type="submit" className="btn btn-create">
            Crear Empresa
          </button>
        </form>
      </div>
    </div>

  );
};

export default CrearEmpresa;
